/* =====================================================================
   TAB Calculator Library — WINE data / config  ·  V2
   Ported verbatim from the approved prototype (calc-data.js: `wine`,
   GROUPS.wine, META, HELP). 12 calculators only, in four groups:
     • Plan your wine  • Measure and adjust  • Stabilise and finish  • Bottle and package
   Loaded only on the Wine page; registers with the shared engine.
   ===================================================================== */
(function () {
  'use strict';

  var num = function (x) { return parseFloat(x); };
  var has = function (x) { return x !== '' && x != null && !isNaN(parseFloat(x)); };
  var d = function (n, dp) { return Number(n).toFixed(dp); };
  var sgToBrix = function (sg) { return (((182.4601 * sg - 775.6821) * sg + 1262.7794) * sg - 669.5622); };

  var wine = [
    {
      id: 'wine-abv',
      name: 'Wine ABV Calculator',
      desc: 'Calculate alcohol percentage from starting and final gravity.',
      group: 'plan', tag: 'Start here',
      need: 'Your hydrometer readings before and after fermentation.',
      accuracy: 'This is an estimate. Actual alcohol content may vary.',
      next: [{ t: 'wine-sulphite', label: 'Add sulphite to protect the wine' }, { h: '/blogs/all/understanding-brix-specific-gravity-and-baume-in-winemaking', label: 'Understanding Brix, SG and Baumé' }],
      fields: [
        { key: 'og', label: 'Starting gravity', type: 'number', unit: 'SG', default: '1.090', step: '0.001', help: 'Your hydrometer reading before fermentation begins.' },
        { key: 'fg', label: 'Final gravity', type: 'number', unit: 'SG', default: '0.995', step: '0.001', help: 'Your hydrometer reading once fermentation is complete.' },
      ],
      compute: function (v, s) {
        if (!has(v.og) || !has(v.fg)) return null;
        if (num(v.og) < 0.9 || num(v.og) > 1.25 || num(v.fg) < 0.9 || num(v.fg) > 1.25) return { error: 'Enter a valid gravity reading.' };
        if (num(v.fg) > num(v.og)) return { error: 'Final gravity should be lower than starting gravity.' };
        var abv = (num(v.og) - num(v.fg)) * 131.25;
        return { main: { value: d(abv, 1), unit: '% ABV', label: 'Estimated ABV' },
          note: 'Your wine is about ' + d(abv, 1) + '% alcohol by volume.' };
      },
    },
    {
      id: 'wine-potential',
      name: 'Potential Alcohol Calculator',
      desc: 'Estimate potential alcohol from a starting reading.',
      group: 'plan',
      need: 'A starting hydrometer or refractometer reading.',
      accuracy: 'Assumes fermentation to fully dry — real wines vary.',
      next: [{ t: 'wine-sugar', label: 'Add sugar to lift alcohol' }],
      fields: [
        { key: 'mtype', label: 'Measurement type', type: 'select', default: 'sg',
          options: [{ value: 'sg', label: 'Specific Gravity' }, { value: 'brix', label: 'Brix' }, { value: 'baume', label: 'Baumé' }] },
        { key: 'reading', label: 'Reading value', type: 'number', unit: '', default: '1.090', step: '0.001', help: 'Your starting reading in the selected unit.' },
      ],
      compute: function (v, s) {
        if (!has(v.reading)) return null;
        var r = num(v.reading), pa;
        if (v.mtype === 'sg' && (r < 0.98 || r > 1.2)) return { error: 'Enter a Specific Gravity between 0.980 and 1.200.' };
        if (v.mtype === 'brix' && (r < 0 || r > 45)) return { error: 'Enter a Brix value between 0 and 45 °Bx.' };
        if (v.mtype === 'baume' && (r < 0 || r > 25)) return { error: 'Enter a Baumé value between 0 and 25 °Bé.' };
        if (v.mtype === 'sg') pa = (r - 1) * 131.25;
        else if (v.mtype === 'brix') pa = r * 0.59;
        else pa = r * 1.0;
        if (pa < 0) return { error: 'Reading is below the point where sugar is present.' };
        return { main: { value: d(pa, 1), unit: '% ABV', label: 'Potential alcohol' },
          note: 'The alcohol you would reach if fermented fully dry.' };
      },
    },
    {
      id: 'wine-converter',
      name: 'Brix / SG / Baumé Converter',
      desc: 'Convert between common wine measurements.',
      group: 'plan',
      need: 'Any one reading — SG, Brix or Baumé.',
      next: [{ t: 'wine-potential', label: 'Estimate potential alcohol' }, { h: '/blogs/all/understanding-brix-specific-gravity-and-baume-in-winemaking', label: 'Understanding Brix, SG and Baumé' }],
      fields: [
        { key: 'mtype', label: 'Input measurement type', type: 'select', default: 'sg',
          options: [{ value: 'sg', label: 'Specific Gravity' }, { value: 'brix', label: 'Brix' }, { value: 'baume', label: 'Baumé' }] },
        { key: 'reading', label: 'Reading value', type: 'number', unit: '', default: '1.090', step: '0.001', help: 'Enter your reading in the selected unit.' },
      ],
      compute: function (v, s) {
        if (!has(v.reading)) return null;
        var r = num(v.reading), sg;
        if (v.mtype === 'sg' && (r < 0.98 || r > 1.2)) return { error: 'Enter a Specific Gravity between 0.980 and 1.200.' };
        if (v.mtype === 'brix' && (r < 0 || r > 45)) return { error: 'Enter a Brix value between 0 and 45 °Bx.' };
        if (v.mtype === 'baume' && (r < 0 || r > 25)) return { error: 'Enter a Baumé value between 0 and 25 °Bé.' };
        if (v.mtype === 'sg') sg = r;
        else if (v.mtype === 'brix') sg = 1 + (r / (258.6 - ((r / 258.2) * 227.1)));
        else sg = 145 / (145 - r);
        var brix = sgToBrix(sg), baume = 145 - 145 / sg, pa = (sg - 1) * 131.25;
        return { main: { value: d(sg, 3), unit: 'SG', label: 'Specific Gravity' },
          extra: [
            { value: d(brix, 1), unit: '°Bx', label: 'Brix' },
            { value: d(baume, 1), unit: '°Bé', label: 'Baumé' },
            { value: d(pa, 1), unit: '% ABV', label: 'Potential alcohol' },
          ],
          note: 'Handy for cross-checking a refractometer against a hydrometer.' };
      },
    },
    {
      id: 'wine-sugar',
      name: 'Sugar Addition Calculator',
      desc: 'Calculate sugar needed to increase potential alcohol.',
      group: 'plan',
      need: 'Your batch volume, and current and target potential alcohol.',
      accuracy: 'An estimate — re-check gravity once the sugar dissolves.',
      next: [{ t: 'wine-abv', label: 'Calculate final ABV' }],
      fields: [
        { key: 'vol', label: 'Batch volume', type: 'number', dim: 'vol', default: '20' },
        { key: 'cur', label: 'Current potential alcohol', type: 'number', unit: '%', default: '10', step: '0.1', help: 'The alcohol your must would reach if fermented dry now.' },
        { key: 'target', label: 'Target potential alcohol', type: 'number', unit: '%', default: '12', step: '0.1', help: 'The alcohol level you are aiming for.' },
      ],
      compute: function (v, s) {
        if (!has(v.vol) || !has(v.cur) || !has(v.target)) return null;
        if (num(v.target) <= num(v.cur)) return { error: 'Target must be higher than the current level.' };
        var g = s.toL(v.vol) * (num(v.target) - num(v.cur)) * 16.83;
        var w = s.wt(g);
        return { main: { value: w.value, unit: w.unit, label: 'Sugar to add' },
          note: 'Dissolve fully and stir through before pitching yeast.' };
      },
    },
    {
      id: 'wine-acid',
      name: 'Acid Adjustment Calculator',
      desc: 'Calculate acid additions for wine.',
      group: 'measure',
      need: 'Your batch volume, and current and target acidity in g/L.',
      accuracy: 'Measured as titratable acidity — re-test after mixing.',
      next: [{ h: '/blogs/all/how-to-balance-acidity-in-homemade-wine', label: 'Balancing acidity in wine' }],
      fields: [
        { key: 'vol', label: 'Batch volume', type: 'number', dim: 'vol', default: '20' },
        { key: 'cur', label: 'Current acidity', type: 'number', unit: 'g/L', default: '5', step: '0.1', help: 'Your measured titratable acidity.' },
        { key: 'target', label: 'Target acidity', type: 'number', unit: 'g/L', default: '7', step: '0.1', help: 'The acidity you want to reach.' },
        { key: 'type', label: 'Acid type', type: 'select', default: 'tartaric',
          options: [{ value: 'tartaric', label: 'Tartaric' }, { value: 'malic', label: 'Malic' }, { value: 'citric', label: 'Citric' }] },
      ],
      compute: function (v, s) {
        if (!has(v.vol) || !has(v.cur) || !has(v.target)) return null;
        if (num(v.target) <= num(v.cur)) return { error: 'Target acidity must be higher than current.' };
        var fac = { tartaric: 1, malic: 0.98, citric: 0.95 }[v.type];
        var g = s.toL(v.vol) * (num(v.target) - num(v.cur)) * fac;
        var w = s.wt(g);
        return { main: { value: w.value, unit: w.unit, label: 'Acid to add' },
          note: 'Measured as titratable acidity (as tartaric). Re-test after mixing.' };
      },
    },
    {
      id: 'wine-dilution',
      name: 'Wine Dilution Calculator',
      desc: 'Calculate water required to reduce wine to a target ABV.',
      group: 'measure',
      need: 'Your current volume, current ABV and target ABV.',
      accuracy: 'This is an estimate. Actual alcohol content may vary.',
      next: [{ t: 'wine-abv', label: 'Calculate ABV' }],
      fields: [
        { key: 'vol', label: 'Current volume', type: 'number', dim: 'vol', default: '20' },
        { key: 'cabv', label: 'Current ABV', type: 'number', unit: '%', default: '14', step: '0.1' },
        { key: 'tabv', label: 'Target ABV', type: 'number', unit: '%', default: '12', step: '0.1' },
      ],
      compute: function (v, s) {
        if (!has(v.vol) || !has(v.cabv) || !has(v.tabv)) return null;
        if (num(v.vol) <= 0) return { error: 'Current volume must be greater than zero.' };
        if (num(v.tabv) >= num(v.cabv)) return { error: 'Target ABV must be lower than current ABV.' };
        var curL = s.toL(v.vol), waterL = curL * (num(v.cabv) / num(v.tabv)) - curL;
        var w = s.vol(waterL), f = s.vol(curL + waterL);
        return { main: { value: w.value, unit: w.unit, label: 'Water to add' },
          extra: [{ value: f.value, unit: f.unit, label: 'Final volume' }],
          note: 'Dilutes flavour and acidity as well as alcohol.' };
      },
    },
    {
      id: 'wine-nutrient',
      name: 'Yeast Nutrient Calculator',
      desc: 'Calculate nutrient additions by batch volume.',
      group: 'measure',
      need: 'Your batch volume, nutrient type and fermentation stage.',
      accuracy: 'Check your specific nutrient product instructions before adding.',
      next: [{ h: '/collections/wine-making', label: 'Explore wine-making resources' }],
      fields: [
        { key: 'vol', label: 'Batch volume', type: 'number', dim: 'vol', default: '20' },
        { key: 'type', label: 'Nutrient type', type: 'select', default: 'complex',
          options: [{ value: 'dap', label: 'DAP' }, { value: 'complex', label: 'Complex nutrient' }, { value: 'energizer', label: 'Yeast energizer' }] },
        { key: 'stage', label: 'Fermentation stage', type: 'select', default: 'start',
          options: [{ value: 'start', label: 'At pitching' }, { value: 'mid', label: 'One-third sugar break' }] },
      ],
      compute: function (v, s) {
        if (!has(v.vol)) return null;
        var rate = { dap: 0.9, complex: 0.5, energizer: 0.3 }[v.type] * (v.stage === 'mid' ? 0.5 : 1);
        var g = s.toL(v.vol) * rate;
        var w = s.wt(g);
        return { main: { value: w.value, unit: w.unit, label: 'Nutrient to add' },
          note: 'Split additions across the first third of fermentation for a clean finish.' };
      },
    },
    {
      id: 'wine-fining',
      name: 'Fining Agent Calculator',
      desc: 'Calculate clearing agent quantities.',
      group: 'measure', tag: 'Advanced',
      need: 'Your batch volume and chosen fining agent.',
      accuracy: 'Check your specific fining product instructions before adding.',
      next: [{ t: 'wine-bottle', label: 'Check bottle yield' }, { h: '/blogs/all/when-and-how-to-use-fining-agents-in-wine', label: 'When and how to use fining agents' }],
      fields: [
        { key: 'vol', label: 'Batch volume', type: 'number', dim: 'vol', default: '20' },
        { key: 'agent', label: 'Fining agent type', type: 'select', default: 'bentonite',
          options: [{ value: 'bentonite', label: 'Bentonite' }, { value: 'isinglass', label: 'Isinglass' }, { value: 'gelatin', label: 'Gelatin' }, { value: 'kieselsol', label: 'Kieselsol' }] },
      ],
      compute: function (v, s) {
        if (!has(v.vol)) return null;
        var volL = s.toL(v.vol);
        var spec = { bentonite: [1.0, 'g'], isinglass: [0.02, 'g'], gelatin: [0.08, 'g'], kieselsol: [1.0, 'mL'] }[v.agent];
        var amt = volL * spec[0], main;
        if (spec[1] === 'mL') { main = { value: d(amt, 1), unit: 'mL', label: 'Fining agent to add' }; }
        else { var w = s.wt(amt); main = { value: w.value, unit: w.unit, label: 'Fining agent to add' }; }
        return { main: main, note: 'Hydrate powders fully first. Rack off sediment once clear.' };
      },
    },
    {
      id: 'wine-backsweeten',
      name: 'Backsweetening Calculator',
      desc: 'Calculate sugar or sweetener additions after fermentation.',
      group: 'stabilise',
      guide: 'Stabilise the wine first (sorbate + sulphite) so it does not re-ferment. Sweetness is measured in grams per litre of residual sugar.',
      need: 'Your batch volume, and current and desired sweetness in g/L.',
      accuracy: 'Stabilise first, then sweeten to taste in small steps.',
      next: [{ t: 'wine-sorbate', label: 'Add sorbate to stabilise' }, { h: '/blogs/all/how-to-stabilise-wine-before-backsweetening', label: 'How to stabilise wine before backsweetening' }],
      fields: [
        { key: 'vol', label: 'Batch volume', type: 'number', dim: 'vol', default: '20' },
        { key: 'cur', label: 'Current sweetness level', type: 'number', unit: 'g/L', default: '0' },
        { key: 'target', label: 'Desired sweetness level', type: 'number', unit: 'g/L', default: '20', help: 'Off-dry ~10 · Medium ~30 · Sweet ~50+' },
        { key: 'type', label: 'Sweetener type', type: 'select', default: 'sugar',
          options: [{ value: 'sugar', label: 'Sugar' }, { value: 'honey', label: 'Honey' }, { value: 'conc', label: 'Grape concentrate' }] },
      ],
      compute: function (v, s) {
        if (!has(v.vol) || !has(v.cur) || !has(v.target)) return null;
        if (num(v.target) <= num(v.cur)) return { error: 'Desired level must be higher than current.' };
        var fac = { sugar: 1, honey: 1.3, conc: 1.5 }[v.type];
        var g = s.toL(v.vol) * (num(v.target) - num(v.cur)) * fac;
        var w = s.wt(g);
        return { main: { value: w.value, unit: w.unit, label: 'Sweetener to add' },
          note: 'Add in small steps and taste — sweetness perception varies.' };
      },
    },
    {
      id: 'wine-sulphite',
      name: 'Sulphite / Campden Addition',
      desc: 'Calculate potassium metabisulphite additions.',
      group: 'stabilise', tag: 'Most used',
      need: 'Your batch volume, current and target free SO₂, and wine pH.',
      accuracy: 'Check your specific product instructions before adding.',
      next: [{ t: 'wine-sorbate', label: 'Add potassium sorbate' }, { t: 'wine-bottle', label: 'Check bottle yield' }],
      fields: [
        { key: 'vol', label: 'Batch volume', type: 'number', dim: 'vol', default: '20' },
        { key: 'cur', label: 'Current free SO₂', type: 'number', unit: 'mg/L', default: '10', help: 'The active sulphite level currently present in your wine.' },
        { key: 'target', label: 'Target free SO₂', type: 'number', unit: 'mg/L', default: '50', help: 'The free SO₂ level you want to protect the wine at.' },
        { key: 'ph', label: 'Wine pH', type: 'number', unit: 'pH', default: '3.4', step: '0.1', help: 'Guides the target — lower pH needs less SO₂.' },
      ],
      compute: function (v, s) {
        if (!has(v.vol) || !has(v.cur) || !has(v.target)) return null;
        if (num(v.vol) <= 0) return { error: 'Check that your batch volume is correct before calculating additions.' };
        if (has(v.ph) && (num(v.ph) < 2.5 || num(v.ph) > 4.5)) return { error: 'Enter a valid pH and free SO₂ target.' };
        if (num(v.target) <= num(v.cur)) return { error: 'Target free SO₂ must be higher than current.' };
        var mg = s.toL(v.vol) * (num(v.target) - num(v.cur)) / 0.57;
        var w = s.wt(mg / 1000);
        var tablets = Math.round(mg / 1000 / 0.44);
        return { main: { value: w.value, unit: w.unit, label: 'Potassium metabisulphite' },
          extra: [{ value: String(tablets), unit: tablets === 1 ? 'tablet' : 'tablets', label: 'Or Campden tablets' }],
          note: has(v.ph) && num(v.ph) > 3.6 ? 'High pH — aim for the upper end of your target range.' : 'Dissolve in a little wine before adding to the batch.' };
      },
    },
    {
      id: 'wine-sorbate',
      name: 'Potassium Sorbate Calculator',
      desc: 'Calculate potassium sorbate for stabilising wine before backsweetening.',
      group: 'stabilise',
      need: 'Your batch volume — pair with sulphite before backsweetening.',
      accuracy: 'Sorbate alone will not prevent re-fermentation — always pair with sulphite.',
      next: [{ t: 'wine-backsweeten', label: 'Backsweeten the wine' }],
      fields: [
        { key: 'vol', label: 'Batch volume', type: 'number', dim: 'vol', default: '20' },
      ],
      compute: function (v, s) {
        if (!has(v.vol)) return null;
        var g = s.toL(v.vol) * 0.198; // ~0.75 g/gal
        var w = s.wt(g);
        return { main: { value: w.value, unit: w.unit, label: 'Potassium sorbate' },
          note: 'Always pair with sulphite — sorbate alone will not prevent re-fermentation.' };
      },
    },
    {
      id: 'wine-bottle',
      name: 'Bottle Yield Calculator',
      desc: 'Calculate bottle quantity from wine batch volume.',
      group: 'bottle', tag: 'Packaging',
      need: 'Your total packaged volume and chosen bottle size.',
      next: [{ h: '/blogs/all/how-to-bottle-homemade-wine', label: 'How to bottle homemade wine' }],
      fields: [
        { key: 'vol', label: 'Total packaged volume', type: 'number', dim: 'vol', default: '20' },
        { key: 'size', label: 'Bottle size', type: 'select', default: '750',
          options: [{ value: '375', label: '375 mL (half)' }, { value: '750', label: '750 mL (standard)' }, { value: '1500', label: '1500 mL (magnum)' }] },
      ],
      compute: function (v, s) {
        if (!has(v.vol)) return null;
        if (num(v.vol) <= 0) return { error: 'Total packaged volume must be greater than zero.' };
        if (num(v.size) <= 0) return { error: 'Bottle size must be greater than zero.' };
        var mL = s.toL(v.vol) * 1000, bottles = Math.ceil(mL / num(v.size));
        return { main: { value: String(bottles), unit: 'bottles', label: 'Bottles required' },
          extra: [{ value: String(bottles), unit: 'closures', label: 'Closures required' }],
          note: 'Rounded up. Allow a little extra for topping up and sampling.' };
      },
    },
  ];

  var CFG = {
    page: 'wine',
    units: 'metric',
    // Group order defines the continuous 01–12 numbering (Plan → Measure → Stabilise → Bottle)
    groups: [
      { id: 'plan', anchor: 'grp-plan', title: 'Plan your wine', learn: [
        { title: 'Understanding Brix, SG and Baumé', kicker: 'Guide', href: '/blogs/all/understanding-brix-specific-gravity-and-baume-in-winemaking' },
        { title: 'Estimating potential alcohol', kicker: 'Guide', href: '/blogs/all/estimating-potential-alcohol-in-homemade-wine' },
      ] },
      { id: 'measure', anchor: 'grp-measure', title: 'Measure and adjust', learn: [
        { title: 'Balancing acidity in wine', kicker: 'Guide', href: '/blogs/all/how-to-balance-acidity-in-homemade-wine' },
        { title: 'When and how to use fining agents', kicker: 'Guide', href: '/blogs/all/when-and-how-to-use-fining-agents-in-wine' },
      ] },
      { id: 'stabilise', anchor: 'grp-stabilise', title: 'Stabilise and finish', learn: [
        { title: 'How to stabilise wine before backsweetening', kicker: 'Guide', href: '/blogs/all/how-to-stabilise-wine-before-backsweetening' },
        { title: 'Sulphite and sorbate basics', kicker: 'Guide', href: '/blogs/all/sulphite-and-sorbate-basics-for-homemade-wine' },
      ] },
      { id: 'bottle', anchor: 'grp-bottle', title: 'Bottle and package', learn: [
        { title: 'How to bottle homemade wine', kicker: 'Guide', href: '/blogs/all/how-to-bottle-homemade-wine' },
      ] },
    ],
    chips: [
      { label: 'Measure alcohol', id: 'wine-abv' },
      { label: 'Add sugar', id: 'wine-sugar' },
      { label: 'Adjust acidity', id: 'wine-acid' },
      { label: 'Stabilise wine', id: 'wine-sulphite' },
      { label: 'Bottle and package', id: 'wine-bottle' },
    ],
    footer: {
      responsible: 'Calculator results are estimates, particularly for homemade beverages. Enjoy what you make, share responsibly and never drink and drive.',
      related: [
        { label: 'Explore wine-making resources', href: '/collections/wine-making' },
        { label: 'Browse fermentation equipment', href: '/collections/fermenters-accessories' },
        { label: 'View bottling supplies', href: '/collections/bottle-closures-packaging' },
      ],
    },
    calculators: wine,
  };

  if (window.TABCalc && window.TABCalc.register) window.TABCalc.register('wine', CFG);
  else { window.TABCalc = window.TABCalc || {}; (window.TABCalc._pending = window.TABCalc._pending || []).push(['wine', CFG]); }
})();
